import { Select, SelectOption } from "rizzui";

export interface StatusAccountProps {
  status: "active" | "inactive";
  onChange: (value: SelectOption) => Promise<void>;
  className?: string;
}

export default function StatusAccount({
  status = "inactive",
  onChange,
  className,
}: StatusAccountProps) {
  return (
    <Select
      className={className}
      value={status}
      onChange={onChange}
      options={[
        { value: "active", label: "Active", color: "green" },
        { value: "inactive", label: "Inactive", color: "red" },
      ]}
      displayValue={(value) => {
        return value === "active" ? "Active" : "Inactive";
      }}
    />
  );
}
